import React, { useEffect } from "react";
import { createPortal } from "react-dom";
import NeatGradientCanvas from "./NeatGradientCanvas";
import { GLASS_LOCK_CSS } from "../../styles/wljGlassLock";
import "./neatGradient.css";
import "./wljNeatGradient.css";

/**
 * App-wide Neat gradient background (FireCMS Neat pattern).
 * Portaled to <body> with z-index: -1 so it sits behind every screen.
 * @see https://github.com/FireCMSco/neat
 */
const AppGradientBackground = () => {
  useEffect(() => {
    document.body.classList.add("wlj-neat-gradient-active");
    return () => {
      document.body.classList.remove("wlj-neat-gradient-active");
    };
  }, []);

  useEffect(() => {
    const LOCK_ID = "wlj-glass-lock";
    let lock = document.getElementById(LOCK_ID);
    if (!lock) {
      lock = document.createElement("style");
      lock.id = LOCK_ID;
      lock.setAttribute("data-wlj-glass-lock", "true");
      document.head.appendChild(lock);
    }
    lock.textContent = GLASS_LOCK_CSS;

    let queued = false;
    const keepLockLast = () => {
      if (queued) return;
      queued = true;
      requestAnimationFrame(() => {
        queued = false;
        if (!lock.isConnected) return;
        if (document.head.lastElementChild !== lock) {
          document.head.appendChild(lock);
        }
      });
    };

    const observer = new MutationObserver((mutations) => {
      for (const mutation of mutations) {
        for (const node of mutation.addedNodes) {
          if (node === lock) continue;
          if (
            node.nodeType === 1 &&
            (node.tagName === "STYLE" || node.tagName === "LINK")
          ) {
            keepLockLast();
            return;
          }
        }
      }
    });
    observer.observe(document.head, { childList: true });
    return () => observer.disconnect();
  }, []);

  return createPortal(
    <div className="wlj-neat-page-background" aria-hidden="true">
      <NeatGradientCanvas scrollSync />
      <div className="wlj-global-gradient-veil" />
    </div>,
    document.body
  );
};

export default AppGradientBackground;
